export var makeTraceHttpRequestHeaders = function makeTraceHttpRequestHeaders(traceId, spanId) {
  return {
    'X-B3-TraceId': traceId,
    'X-B3-SpanId': spanId
  };
};